
const authRouter = {
  component: () => import('@/modules/auth/layouts/auth/AuthLayout.vue'),
  children: [
    { path: 'login', name: 'auth-login', component: () => import('@/modules/auth/pages/login/Login.vue') },
    { path: 'change-password', name: 'auth-change', component: () => import('@/modules/auth/pages/changepassword/ChangePassword.vue') },
    { path: '*', redirect: 'login' },
    { path: '', redirect: 'login' }
  ]
}

export default authRouter
